const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_WISHLIST_PRICE = 'shopify-wishlist-price';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const BUTTON_ACTIVE_TEXT = 'Added to wishlist';
const BUTTON_TEXT = 'Add to wishlist';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]', 
  productCard: '.ProductItem',
};

document.addEventListener('DOMContentLoaded', () => { 
  initButtons();
  initGrid();
  initSortingButtons();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});
document.addEventListener('theme:loading:end', (event) => {
  // console.log('theme:loading:end', event.detail); 
  setTimeout(function(){initButtons();},1000);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCardWrapper = document.createElement('div');
    productCardWrapper.className="Grid__Cell 1/1--phone 1/4--tablet-and-up";
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    productCardWrapper.appendChild(productCard);
    return productCardWrapper.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  console.log('wishlistProductCards', wishlistProductCards)
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  var counterText = wishlist.length + (( wishlist.length != 1 ) ? ' Products' : ' Product');
  if(wishlist.length == 0){
    document.querySelector('section[id="wishlist"]').classList.add('empty')
  }else{
    document.querySelector('section[id="wishlist"]').classList.remove('empty')
  }
  document.querySelector('.products-counter').innerText = counterText;

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    const productPrice = button.dataset.productPrice || 0;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
        // button.querySelector('span').innerText=BUTTON_ACTIVE_TEXT;
    }
    button.addEventListener('click', () => {
      updateWishlist(productHandle, productPrice);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      if(button.classList.contains('active')){
        // button.querySelector('span').innerText=BUTTON_ACTIVE_TEXT;
      }else{
        // button.querySelector('span').innerText=BUTTON_TEXT;
      }
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  setTimeout(() => {
    handleShippingTaxes();
  }, 5000);
};

const initSortingButtons = () => {
  const sortOtopns = document.querySelectorAll('button[data-action="toggle-sort"]');
  if(sortOtopns.length ){
    sortOtopns.forEach( (btn)=>{
      btn.addEventListener('click', function(){
        if(!btn.parentElement.classList.contains('is-selected')){
          //deselect current 
          document.querySelector('li[class="Linklist__Item is-selected"]').classList.remove('is-selected');
          //new selection
          btn.parentElement.classList.add('is-selected') 
          const newSortVal = btn.getAttribute('data-tag');
          // console.log('sort ', newSortVal);
          const event = new CustomEvent('shopify-wishlist:updated', {
            detail: { wishlist: [] }
          });
          document.dispatchEvent(event);
        }
      })
    })
  }
}
const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  //do the sorting and return the sorted handles 
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  const wishlistPrice = localStorage.getItem(LOCAL_STORAGE_WISHLIST_PRICE) || false;
  if(!wishlist.length)
    return [];
  if(!document.querySelector('li[class="Linklist__Item is-selected"] button') )//not the wishlist page -- no sorting 
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  const sortingType = document.querySelector('li[class="Linklist__Item is-selected"] button').dataset.tag;
  // console.log('sortingType ', sortingType)

  if(sortingType == 'recently') 
    return wishlist.split(LOCAL_STORAGE_DELIMITER);

  if (wishlist){
    let wishlistArr = wishlist.split(LOCAL_STORAGE_DELIMITER);
    let wishlistPriceArr = wishlistPrice.split(LOCAL_STORAGE_DELIMITER);
    let handlePricePairs = [];
    wishlistArr.forEach( (handle,index)=>{
      handlePricePairs.push({handle : handle, price : wishlistPriceArr[index]})
    });
    // console.log('before sort ', handlePricePairs)
    if(sortingType == 'alphabetical'){
      handlePricePairs.sort(function(a,b){
        return a.handle.localeCompare( b.handle );
      });
      // console.log('after sort ', handlePricePairs)
      sortedWishlist = [];
      handlePricePairs.forEach( (pair)=>{
        sortedWishlist.push(pair.handle)
      });
      return sortedWishlist;
    }
    else if(sortingType == 'descengin-price'){
      handlePricePairs.sort(function(a,b){
        return b.price - a.price;
      });
      // console.log('after sort ', handlePricePairs)
      sortedWishlist = [];
      handlePricePairs.forEach( (pair)=>{
        sortedWishlist.push(pair.handle)
      });
      return sortedWishlist;
    }
    else if(sortingType == 'ascengin-price'){
      handlePricePairs.sort(function(a,b){
        return a.price - b.price;
      });
      // console.log('after sort ', handlePricePairs)
      sortedWishlist = [];
      handlePricePairs.forEach( (pair)=>{
        sortedWishlist.push(pair.handle)
      });
      return sortedWishlist;
    }

    return wishlistArr;
  }
  return [];
};

const getWishlistPrice = () => {
  const wishlistPrice = localStorage.getItem(LOCAL_STORAGE_WISHLIST_PRICE) || false;
  if (wishlistPrice) return wishlistPrice.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const setWishlistPrice = (array) => {
  const wishlistPrice = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_PRICE, wishlistPrice);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_PRICE);

  return wishlistPrice;
};

const updateWishlist = (handle, price) => {
  const wishlist = getWishlist();
  const wishlistPrice = getWishlistPrice();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {
    wishlist.push(handle);
    wishlistPrice.push(price);
  }
  else {
    wishlist.splice(indexInWishlist, 1);
    wishlistPrice.splice(indexInWishlist, 1);
  }
  setWishlistPrice(wishlistPrice);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};